module.exports	= {
	format: function (number) {
		return 'M$' + new Intl.NumberFormat().format(Math.floor(number))
	},
	randomString(length = 16, chars="0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
		let string = ''
		for (var i = 0; i <= length; i++) {
				var randomNumber = Math.floor(Math.random() * chars.length);
				string += chars.substring(randomNumber, randomNumber +1);
			}
			return string;
		},
}
